import styles from './Knob.module.css';

type KnobProps = {
  ariaLabel: string;
  selected: boolean;
  onClick: () => void;
};

export function Knob({ ariaLabel, selected, onClick }: KnobProps) {
  return (
    <button
      className={`${styles.track} ${selected ? styles.track_on : ''}`}
      aria-label={ariaLabel}
      role="switch"
      type="button"
      aria-checked={selected}
      onClick={onClick}
    >
      <div className={`${styles.knob} ${selected ? styles.knob_on : ''}`} />
    </button>
  );
}
